import React, { useState } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddOtherIncomeItem = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    incomeGroup: '',
    incomeItem: '',
    remark: '',
  });

  const navigate = useNavigate();

  // Static data for other income groups
  const incomeGroups = [
    { id: 1, name: 'Investments' },
    { id: 2, name: 'Rental Income' },
    { id: 3, name: 'Freelance' },
    { id: 4, name: 'Dividends' },
    { id: 5, name: 'Royalties' },
    { id: 6, name: 'Gifts' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    // Check if all required fields are filled
    if (!formData.incomeGroup || !formData.incomeItem || !formData.remark) {
      alert('Please fill all fields');
      return;
    }
    setShowSuccessModal(true);
  };

  const handleCancel = () => {
    setFormData({
      incomeGroup: '',
      incomeItem: '',
      remark: '',
    });
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: '100%',
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Other Income Item
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="income-group-label">Other Income Group</InputLabel>
              <Select
                labelId="income-group-label"
                id="incomeGroup"
                name="incomeGroup"
                value={formData.incomeGroup}
                label="Other Income Group"
                onChange={handleChange}
              >
                {incomeGroups.map((group) => (
                  <MenuItem key={group.id} value={group.name}>
                    {group.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Other Income Item"
              variant="outlined"
              fullWidth
              name="incomeItem"
              value={formData.incomeItem}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Remark"
              variant="outlined"
              fullWidth
              name="remark"
              value={formData.remark}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tooltip
              title={
                (!formData.incomeGroup && 'Select Other Income Group') ||
                (!formData.incomeItem && 'Enter Other Income Item') ||
                (!formData.remark && 'Enter Remark')
              }
              arrow
            >
              <Button
                variant="contained"
                type="submit"
                sx={{ mr: 2, backgroundColor: '#127498ff', '&:hover': { backgroundColor: '#116280ff' } }}
                disabled={!formData.incomeGroup || !formData.incomeItem || !formData.remark}
              >
                SAVE
              </Button>
            </Tooltip>
            <Button variant="contained" color="error" onClick={handleCancel}>
              RESET
            </Button>
          </Box>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Other Income Item Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Other Income Item Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddOtherIncomeItem;
